import { render, staticRenderFns } from "./textbook-folder.vue?vue&type=template&id=d3b82f3c&scoped=true&"
import script from "./textbook-folder.vue?vue&type=script&lang=ts&"
export * from "./textbook-folder.vue?vue&type=script&lang=ts&"
import style0 from "./textbook-folder.vue?vue&type=style&index=0&id=d3b82f3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b82f3c",
  null
  
)

export default component.exports